import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useContext } from "react";
import { GlobalMenuContext } from "../context/GlobalMenuContext";
import PWAInstallPrompt from "./PWAInstallPrompt";

function Layout() {
  const { menus = [], loading = true, error } = useContext(GlobalMenuContext);

  const handleOverlayClick = () => {
    document.body.classList.remove("vertical-sidebar-enable");
    document.body.classList.remove("menu");
    if (sessionStorage.getItem("data-layout") === "twocolumn") {
      document.body.classList.add("twocolumn-panel");
    } else {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        sessionStorage.getItem("data-sidebar-size") || "lg"
      );
    }
  };

  return (
    <div id="data-layout">
      <Navbar />
      <Sidebar menus={menus} loading={loading} error={error} />

      <div className="vertical-overlay" onClick={handleOverlayClick}></div>
      <div className="main-content">
        <div className="page-content">
          <Outlet />
        </div>
      </div>
      <PWAInstallPrompt />
    </div>
  );
}

export default Layout;
